// extracted by mini-css-extract-plugin
export var logo = "_bb-2";
export var logoWrapper = "_bb-1";
export var strip = "_bb-0";